import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["imageIdField", "preview"]
  static values = { pickerUrl: String, fieldId: String }

  connect() {
    this.handleSelection = this.handleSelection.bind(this)
    window.addEventListener("imagePicker:selected", this.handleSelection)
  }

  disconnect() {
    window.removeEventListener("imagePicker:selected", this.handleSelection)
  }

  handleSelection(event) {
    if (event.detail.fieldId !== this.fieldIdValue) return
    this.imageIdFieldTarget.value = event.detail.id
    this.previewTarget.innerHTML = `<img src="${event.detail.url}" class="img-fluid rounded" width="300">`
  }

  openPicker() {
    window.dispatchEvent(new CustomEvent("imagePicker:open", {
      detail: { fieldId: this.fieldIdValue, pickerUrl: this.pickerUrlValue }
    }))
  }

  removeImage() {
    this.imageIdFieldTarget.value = ""
    this.previewTarget.innerHTML = ""
  }
}
